import fileUpload from 'v-file-upload';
import axiosCommon from '@/axios-common/axios-common';

export default {
  name: 'custom-file-upload',
  components: {
    fileUpload
  },
  data() {
    return {
      url: `${axiosCommon.defaults.baseURL}r/fellows/data/upload`,
      headers: { 'authorization': localStorage.getItem('token') },
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet',
      filesUploaded: []
    }
  },
  methods: {
    onFileChange(file) {
      let vm = this;
      vm.fileUploaded = file;
    },
    onError() {
      let vm = this;
      vm.$snotify.error('Failed to upload excel', 'Error');
    },
    onSuccess() {
      let vm = this;
      vm.$snotify.success('Excel uploaded successfully', 'Success');
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/custom-file-upload/custom-file-upload.js